import React from "react";

const ShiftTiming = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3606_3)">
      <rect x="4" y="4" width="24" height="24" rx="4" fill="#FFF8EF" />
    </g>
    <path
      d="M16.0025 10.5566C13.003 10.5566 10.5625 12.9971 10.5625 15.9966C10.5625 18.9962 13.003 21.4366 16.0025 21.4366C19.002 21.4366 21.4425 18.9962 21.4425 15.9966C21.4425 12.9971 19.002 10.5566 16.0025 10.5566ZM16.0025 20.7966C13.355 20.7966 11.2025 18.6441 11.2025 15.9966C11.2025 13.3491 13.355 11.1966 16.0025 11.1966C18.65 11.1966 20.8025 13.3491 20.8025 15.9966C20.8025 18.6441 18.65 20.7966 16.0025 20.7966Z"
      fill="#C89001"
    />
    <path
      d="M13.3529 12.8959C13.3359 12.8745 13.3145 12.8618 13.2996 12.8511C13.2868 12.8425 13.2718 12.8361 13.242 12.8211L13.1866 12.8041C13.0799 12.7849 12.9711 12.819 12.8985 12.8937C12.8686 12.9236 12.8431 12.9599 12.8282 12.9961C12.8133 13.0345 12.8047 13.0751 12.8047 13.1199C12.8047 13.1626 12.8111 13.201 12.8282 13.2415C12.8431 13.2778 12.8666 13.314 12.8965 13.3418C12.9541 13.4015 13.0373 13.4378 13.1248 13.4378C13.1418 13.4378 13.1696 13.4378 13.1824 13.4313C13.1994 13.4292 13.2208 13.4228 13.2527 13.41C13.2676 13.4014 13.2826 13.3951 13.3018 13.3844C13.3167 13.3737 13.3381 13.3587 13.3509 13.3438C13.3808 13.3139 13.4064 13.2777 13.4213 13.2393C13.4362 13.2009 13.4426 13.1625 13.4426 13.1198C13.4426 13.0728 13.4341 13.0323 13.4191 12.9961C13.4041 12.9578 13.3807 12.9236 13.3529 12.8959L13.3529 12.8959Z"
      fill="#C89001"
    />
    <path
      d="M13.4168 18.7407C13.4104 18.7258 13.4019 18.713 13.3933 18.6959C13.3848 18.6832 13.372 18.664 13.3528 18.6468C13.3358 18.6276 13.3187 18.6149 13.2995 18.6041C13.2867 18.5956 13.2717 18.5892 13.2419 18.5742L13.1886 18.5572C13.1267 18.5444 13.0627 18.5507 13.0008 18.5764C12.9582 18.5934 12.9219 18.619 12.907 18.6382C12.8835 18.6574 12.8665 18.6788 12.8537 18.698C12.8451 18.7107 12.8388 18.7257 12.8259 18.7556C12.8195 18.7748 12.8132 18.7918 12.8153 18.7961C12.8047 18.826 12.8047 18.8515 12.8047 18.8707C12.8047 18.9134 12.8133 18.954 12.8282 18.9945C12.8431 19.0307 12.8666 19.067 12.8965 19.0948C12.9541 19.1545 13.0373 19.1907 13.1248 19.1907C13.1418 19.1907 13.1696 19.1907 13.1824 19.1843C13.1994 19.1822 13.2208 19.1757 13.2527 19.163C13.2676 19.1544 13.2826 19.1481 13.3018 19.1373C13.3167 19.1267 13.3381 19.1117 13.3509 19.0968C13.3808 19.0669 13.4064 19.0307 13.4213 18.9923C13.4362 18.9539 13.4426 18.9133 13.4426 18.8707C13.4426 18.8536 13.4426 18.8323 13.4362 18.8003L13.4168 18.7407Z"
      fill="#C89001"
    />
    <path
      d="M19.1069 18.6478C18.9917 18.5326 18.7656 18.5369 18.6589 18.6435C18.6269 18.6713 18.6034 18.7075 18.5842 18.7502C18.5672 18.7908 18.5586 18.8313 18.5586 18.8718C18.5586 18.9572 18.5927 19.0383 18.6524 19.0958C18.71 19.1556 18.7932 19.1918 18.8786 19.1918C18.9661 19.1918 19.0492 19.1577 19.1048 19.098C19.1645 19.0383 19.1986 18.9572 19.1986 18.8718C19.1986 18.827 19.19 18.7865 19.1751 18.7502C19.1623 18.714 19.1367 18.6777 19.1069 18.6478H19.1069Z"
      fill="#C89001"
    />
    <path
      d="M18.6546 12.8924C18.5927 12.95 18.5586 13.0332 18.5586 13.1186C18.5586 13.2061 18.5948 13.2892 18.6524 13.3426C18.71 13.4045 18.7932 13.4407 18.8786 13.4407C18.9639 13.4407 19.045 13.4066 19.1026 13.3469C19.1623 13.2893 19.1986 13.2061 19.1986 13.1186C19.1986 13.0311 19.1645 12.95 19.1069 12.8946C18.9938 12.7751 18.772 12.7751 18.6546 12.8924L18.6546 12.8924Z"
      fill="#C89001"
    />
    <path
      d="M16.0036 12.6428C16.1806 12.6428 16.3236 12.4999 16.3236 12.3228V11.7809C16.3236 11.6039 16.1806 11.4609 16.0036 11.4609C15.8265 11.4609 15.6836 11.6039 15.6836 11.7809V12.3228C15.6836 12.4999 15.8265 12.6428 16.0036 12.6428Z"
      fill="#C89001"
    />
    <path
      d="M12.3267 15.6758H11.7848C11.6078 15.6758 11.4648 15.8187 11.4648 15.9958C11.4648 16.1728 11.6078 16.3158 11.7848 16.3158H12.3267C12.5038 16.3158 12.6467 16.1728 12.6467 15.9958C12.6467 15.8187 12.5038 15.6758 12.3267 15.6758Z"
      fill="#C89001"
    />
    <path
      d="M16.0036 19.3535C15.8265 19.3535 15.6836 19.4965 15.6836 19.6735V20.2154C15.6836 20.3924 15.8265 20.5354 16.0036 20.5354C16.1806 20.5354 16.3236 20.3924 16.3236 20.2154V19.6735C16.3236 19.4965 16.1806 19.3535 16.0036 19.3535Z"
      fill="#C89001"
    />
    <path
      d="M20.2212 15.6758H19.6794C19.5023 15.6758 19.3594 15.8187 19.3594 15.9958C19.3594 16.1728 19.5023 16.3158 19.6794 16.3158H20.2212C20.3983 16.3158 20.5412 16.1728 20.5412 15.9958C20.5412 15.8187 20.3983 15.6758 20.2212 15.6758Z"
      fill="#C89001"
    />
    <path
      d="M17.8574 15.6772H16.3236V13.322C16.3236 13.1449 16.1806 13.002 16.0036 13.002C15.8265 13.002 15.6836 13.1449 15.6836 13.322V15.9972C15.6836 16.1742 15.8265 16.3172 16.0036 16.3172H17.8574C18.0345 16.3172 18.1774 16.1742 18.1774 15.9972C18.1774 15.8201 18.0345 15.6772 17.8574 15.6772Z"
      fill="#C89001"
    />
    <defs>
      <filter
        id="filter0_d_3606_3"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3606_3"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3606_3"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default ShiftTiming;
